import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authApi } from "@/lib/api";
import { useAuth } from "@/lib/store";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = loc.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    (async () => {
      try {
        const { user } = await authApi.googleSession(m[1]);
        setUser(user);
        window.history.replaceState({}, "", "/");
        nav("/", { replace: true, state: { user } });
      } catch (e) { nav("/login"); }
    })();
  }, [loc, nav, setUser]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center gap-3">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-muted-foreground text-sm">Completing sign-in…</p>
    </div>
  );
}
